/**
 * RoleLayout
 * This is the main layout of the app
 */

import React, { Component } from "react"
import LayoutContainer from "components/LayoutContainer"
import { Header, Body } from "./styles"
import Logo from "components/Logo"
import theme from "styles/theme-main"
import { ThemeProvider } from "styled-components"
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles"
import { MessageContainer, MessageIcon, MessageContent } from "styles/Common"
import Icon from "components/Icon"
import Text from "components/Text"
import Footer from "components/Footer"

import { getHomeRoute, checkTextForEmail, convertMUI } from "utils/utils"
import {
  getSubdomainFromUrl,
  isHRPath,
  isCandidXMode,
  isProfileMode,
} from "utils/productUtils"
import AuthService from "services/auth"
import Maintenance from "components/Maintenance"
export const LAYOUT_NAME = "RoleLayout"

class RoleLayout extends Component {
  loadHomeRoute = props => {
    const isLoggedIn = AuthService.loggedIn()
    if (props.match.url === "/") {
      if (!isLoggedIn) {
        if (isCandidXMode()) {
          props.history.push("/login")
        } else if (isProfileMode()) {
          props.history.push("/signup")
        } else if (isHRPath()) {
          props.history.push("/login")
        } else {
          props.history.push("/roles")
        }
      } else if (props.user && props.user.id) {
        const home = getHomeRoute(props.user, props.organization, true)
        if (home.pathname) {
          props.history.push({
            ...home,
          })
        } else {
          props.history.push(home)
        }
      }
    }
  }

  componentDidMount() {
    const subdomain = getSubdomainFromUrl()
    if (subdomain && !this.props.organization) {
      this.props.getOrganization(subdomain)
    }
    const isLoggedIn = AuthService.loggedIn()
    if (!isLoggedIn) {
      this.loadHomeRoute(this.props)
    }
  }

  componentWillUpdate(nextProps) {
    const isLoggedIn = AuthService.loggedIn()
    if (isLoggedIn && nextProps.user && nextProps.user.id) {
      this.loadHomeRoute(nextProps)
    }
  }

  render() {
    const props = this.props

    const { process } = props
    const success = process && process.status === "done"

    if (props.organization) {
      const orgtheme = JSON.parse(props.organization.themeConfiguration || "{}")
      theme.logoWidth = orgtheme.logoWidth
      theme.logoMargin = orgtheme.logoMargin
      if (orgtheme.headerBGcolour) {
        theme.colors.headerBGcolour = orgtheme.headerBGcolour
      } else {
        theme.colors.headerBGcolour = "#ffffff"
      }
      theme.typography.fonts.regular = "Europa"
      theme.colors.primary = orgtheme.secondary || theme.colors.secondary
      theme.colors.secondary = orgtheme.secondary || theme.colors.secondary

      theme.menuItems.active = theme.colors.secondary
      theme.menuItems.selected = theme.colors.secondary

      theme.menuItemsText.active = theme.colors.secondary
      theme.menuItemsText.selected = theme.colors.secondary

      theme.buttons.primary.background = theme.colors.secondary
      if (isProfileMode()) {
        theme.buttons.secondary.background = theme.colors.secondary
      }
    }

    theme.colors.headerBGcolour = isProfileMode()
      ? theme.colors.profileHeader
      : theme.colors.headerBGcolour

    const muitheme = createTheme(convertMUI(theme))
    const logoURL = props.organization && props.organization.logoURL
    const mainStyle = {}

    let homePath = ""
    if (isProfileMode()) {
      homePath = getHomeRoute(props.user, props.organization)
    }

    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muitheme}>
          <div style={mainStyle}>
            <Maintenance />
            <Header {...props}>
              <LayoutContainer>
                <Logo
                  path={homePath}
                  logoURL={logoURL}
                  logoWidth={theme.logoWidth}
                  logoMargin={theme.logoMargin}
                />
              </LayoutContainer>
            </Header>

            {/* This displays a success or error message if the redux process module has showOn="RoleLayout" */}
            {process && process.showOn === LAYOUT_NAME ? (
              <MessageContainer success={success} variant={"profile"}>
                <LayoutContainer>
                  <MessageContent success={success}>
                    <MessageIcon success={success}>
                      {success ? (
                        <Icon variant={"tick_circle"} />
                      ) : (
                        <Icon variant={"warning"} />
                      )}
                    </MessageIcon>
                    <Text variant={"message"}>
                      {checkTextForEmail(process.message)}
                    </Text>
                  </MessageContent>
                </LayoutContainer>
              </MessageContainer>
            ) : null}

            <Body hasMessage={process && process.showOn === LAYOUT_NAME}>
              <LayoutContainer>{props.children}</LayoutContainer>
            </Body>
            <Footer />
          </div>
        </MuiThemeProvider>
      </ThemeProvider>
    )
  }
}

export default RoleLayout
